import withStyles from '@mui/styles/withStyles';
import MuiDialogContent from '@mui/material/DialogContent';

const DialogContent = withStyles(theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

export default DialogContent;
